/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";

import matchSorter from "match-sorter";
import { isEmpty } from "lodash";
import ReactTable from "react-table";
import Loading from "../../common/Loading";
import ResponsiveDataComponent from "../../common/ResponsiveDataComponent";
import TableActions from "../../common/TableActions";
import { PhoneNumber as phoneNumber } from "../../../helpers";

const CustomerLocationList = ({
  customer,
  search,
  onClickView,
  onClickDelete,
  isMobile,
  minimal
}) => {
  const columns = !isMobile
    ? [
        {
          Header: "Name",
          accessor: "name"
        },
        {
          Header: "Address",
          accessor: "address.addr1"
        },
        {
          Header: "City",
          accessor: "address.city"
        },
        {
          Header: "State",
          accessor: "address.state.value"
        },
        {
          Header: "Phone",
          accessor: "phone",
          Cell: (row) => phoneNumber(row.value)
        }
      ]
    : [
        {
          Header: "Name",
          accessor: "name"
        }
      ];

  columns.push({
    Header: "",
    accessor: "_id",
    maxWidth: 80,
    Cell: (row) => (
      <TableActions
        onClickView={() => onClickView(row.value)}
        onClickDelete={() => onClickDelete(row.value)}
      />
    )
  });

  let { locations } = customer;

  if (search) {
    locations = matchSorter(customer.locations, search, {
      keys: [
        "name",
        "address.addr1",
        "address.city",
        "address.state.label",
        "address.phone"
      ]
    });
  }

  const props = {
    getTdProps: (state, rowInfo, column) => {
      if (!column.expander && rowInfo?.original?._id) {
        return {
          onClick: () => {
            if (column.id !== "_id") {
              onClickView(rowInfo.original._id);
            }
          }
        };
      }
      return {};
    }
  };

  const isLoading = !isEmpty(customer) && locations && !locations.length;
  locations = locations || [];

  return (
    <ReactTable
      className="-highlight"
      data={locations}
      columns={columns}
      showPagination={!minimal}
      pageSize={minimal ? locations.length + 1 : 10}
      noDataText="No locations found"
      LoadingComponent={() => <Loading active={isLoading} timeout={1000} />}
      {...props}
      SubComponent={
        isMobile
          ? (row) => (
              <ResponsiveDataComponent
                data={[
                  { key: "Name", label: row.original.name },
                  { key: "Address", label: row.original.address.addr1 },
                  {
                    key: "City",
                    label: row.original.address.city
                  },
                  {
                    key: "State",
                    label: row.original.address.state.value
                  },
                  {
                    key: "Phone",
                    label: phoneNumber(row.original.phone)
                  }
                ]}
              />
            )
          : false
      }
    />
  );
};

CustomerLocationList.propTypes = {
  search: PropTypes.string,
  isMobile: PropTypes.bool,
  minimal: PropTypes.bool,
  customer: PropTypes.object.isRequired,
  onClickView: PropTypes.func.isRequired,
  onClickDelete: PropTypes.func.isRequired
};

export default CustomerLocationList;
